import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { backendDomain } from "utils/envConfig";
import bytesConverter from "utils/bytesConverter";
import datetimeConverter from "utils/datetimeConverter";
import { logOut } from "redux/loginSlice";
import AggregatedStatusIcon from "components/Submit/AggregatedStatusIcon";
import checkValidJsonParse from "utils/checkValidJsonParse";
import doApiRequest from "utils/doApiRequest";

// css-related components
import toast from "react-hot-toast";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import ProgressBar from "react-bootstrap/ProgressBar";
import Stack from "react-bootstrap/Stack";
import { alpha } from "@mui/material/styles";
// import MuiButton from "@mui/material/Button";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Backdrop from "@mui/material/Backdrop";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
// import TableFooter from "@mui/material/TableFooter";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

// material ui icons
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import NotesIcon from "@mui/icons-material/Notes";
import TopicIcon from "@mui/icons-material/Topic";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import EventIcon from "@mui/icons-material/Event";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import AnnouncementRoundedIcon from "@mui/icons-material/AnnouncementRounded";

import { Spinner } from "react-activity";
import "react-activity/dist/library.css";

import "components/Submit/SubmitCreate.css";

const schema = yup.object().shape({
  file_select: yup
    .mixed()
    .required("A file is required")
    .test(
      "fileSize",
      `Only tar.gz files up to ${bytesConverter(
        process.env.REACT_APP_FILE_LIMIT,
        "GB"
      )} are permitted`,
      (value, context) => {
        return (
          value && value.size <= parseInt(process.env.REACT_APP_FILE_LIMIT, 10)
        );
      }
    ),
});

const Submissions = () => {
  /*
   * Main component of the entire Submissions page
   */
  console.log(localStorage);

  return <></>;
};

export default Submissions;
